import { render, staticRenderFns } from "./data19.vue?vue&type=template&id=7ece230a&scoped=true&"
import script from "./data19.vue?vue&type=script&lang=js&"
export * from "./data19.vue?vue&type=script&lang=js&"
import style1 from "./data19.vue?vue&type=style&index=1&id=7ece230a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ece230a",
  null
  
)

export default component.exports